
import React, { useState,useEffect,useRef } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Typography,
  IconButton,
  Button,
  InputBase,
  Select,
  Menu,
  MenuItem,
  Pagination,
  
  TablePagination,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SearchIcon from '@mui/icons-material/Search';
import CustomText, { textStyles } from "../../../../components/CustomText";
import arrow from "../../../../assets/arrow.svg";
import invited from "../../../../assets/Dashboard/invited.svg";
import tablefilter from "../../../../assets/tablefilter.svg";
import clienttrial from "../../../../assets/Dashboard/clienttrial.svg";
import ClientsTrialDetails from '../../ClientAcquisition/ClientsTrial/ClientTrialDetails';
import { pdf } from '@react-pdf/renderer';
import { CircularProgress } from '@mui/material';
import active from "../../../../assets/Dashboard/active.svg";
import ActiveDetails from './ActiveDetails';
import ActiveCompaniesPDF from './ActiveCompaniesPDF';
import FilterDrawer from './FilterDrawer';
import StatusDropdown from '../../../../components/StatusDropdown';
import ExportDropdown from '../../../../components/ExportDropdown';
import VisibilityIcon from '@mui/icons-material/Visibility';
import NorthIcon from '@mui/icons-material/North'; // Ascending
import SouthIcon from '@mui/icons-material/South';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../../../components/BaseUrl';
import { decryptToken } from "../../../../Utlis/Encryption";
import {toast,Toaster} from 'react-hot-toast';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import emptyscreen from "../../../../assets/Dashboard/emptyscreen.svg"
import ArrowStatusDropdown from '../../../../components/ArrowStatusDropdown';
import ExportActiveCompaniesExcel from "./ActiveDetailsExcel";
import DeleteAccountExecutiveModal from './DeleteModal';
import ActivePins from './ActivePins';
import { convertUTCToLocalDateTime } from "../../../../components/dateTime";
const ActiveCompanies= () => {
  const [selected, setSelected] = useState([]);
  const [tableProcessing, setTableProcessing] = useState(false);

  const { t } = useTranslation();
  const navigate = useNavigate();

const [searchTerm, setSearchTerm] = useState('');
const [selectedClientId, setSelectedClientId] = useState(null);
  const handleSelect = (id) => {
    setSelected(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };
const [tableRows, setTableRows] = useState([]);
const [originalRows, setOriginalRows] = useState([]);
//  const [originalRows, setOriginalRows] = useState(data);
//   const [tableRows, setTableRows] = useState(data);
const [loading, setLoading] = useState(false);
const [page, setPage] = useState(0);  
const [rowsPerPage, setRowsPerPage] = useState(6);
const [totalRows, setTotalRows] = useState(0); 
const [totalPages, setTotalPages] = useState(1);
  const handleChangePage = (_, newPage) => setPage(newPage);
const [statusUpdating, setStatusUpdating] = useState(null);
const [rowStatusUpdatingId, setRowStatusUpdatingId] = useState(null);
const [sortConfig, setSortConfig] = useState({ key: "date", direction: "desc" })
  const sortTriggeredByUser = useRef(false)
      const rawEncryptedToken = localStorage.getItem("token");
    const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
const [firstLoadDone, setFirstLoadDone] = useState(false);
const [filters, setFilters] = useState({
  subscription_plan: '',
  subscription_status: '',
  verification_status: '',
  start_date: '',
  end_date: '',
  country:'',
  state:'',
  city:''
});

const INITIAL_FILTERS = {
  subscription_plan: '',
  subscription_status: '',
  verification_status: '',
  start_date: '',
  end_date: '',
   country:'',
  state:'',
  city:''
};

const planNameMap = {
  attendance_yearly: "Attendance Yearly",
  attendance_monthly: "Attendance Monthly",
  full_monthly: "Full Monthly",
  full_yearly: "Full Yearly",
};
const fetchCompanyAdmins = async (
  pageNum = 0,
  limit = 6,
  sortBy = 'email',
  sortOrder = 'desc',
  isSortTriggered = false,
  keyword = '' ,
    appliedFilters = {} 
) => {
 
    const isInitialLoad = !firstLoadDone;

  if (isInitialLoad) {
    setLoading(true);
  } else {
    setTableProcessing(true);
  }
  try {
    console.log("🧪 Filters received:", appliedFilters);
console.log("🔍 Search keyword:", keyword);
console.log("📤 Pagination:", { pageNum, limit });
const queryParams = new URLSearchParams({
  page: pageNum + 1,
  limit,
  sort_by: sortBy,
  sort_order: sortOrder.toUpperCase(),
  status: 'active'
});

if (keyword) queryParams.append('search', keyword);
if (appliedFilters.subscription_plan) {
  queryParams.append('subscription_plan', appliedFilters.subscription_plan);
}
// COUNTRY filter
if (appliedFilters.country) {
  queryParams.append('country', appliedFilters.country);
}

// STATE filter (province → state for backend)
if (appliedFilters.state) {
  queryParams.append('state', appliedFilters.state);
}

// CITY filter
if (appliedFilters.city) {
  queryParams.append('city', appliedFilters.city);
}
if (appliedFilters.subscription_status) {
  queryParams.append('subscription_status', appliedFilters.subscription_status);
}

if (appliedFilters.verification_status && appliedFilters.verification_status !== 'all') {
  queryParams.append('verification_status', appliedFilters.verification_status);
}

if (appliedFilters.start_date) {
  queryParams.append('start_date', appliedFilters.start_date);
}
if (appliedFilters.end_date) {
  queryParams.append('end_date', appliedFilters.end_date);
}

if (appliedFilters.trial_end_date_from) {
  queryParams.append(
    "trial_end_date_from",
    appliedFilters.trial_end_date_from
  );
}

if (appliedFilters.trial_end_date_to) {
  queryParams.append(
    "trial_end_date_to",
    appliedFilters.trial_end_date_to
  );
}

if (appliedFilters.subscription_start_date_from) {
  queryParams.append(
    "subscription_start_date_from",
    appliedFilters.subscription_start_date_from
  );
}

if (appliedFilters.subscription_start_date_to) {
  queryParams.append(
    "subscription_start_date_to",
    appliedFilters.subscription_start_date_to
  );
}
const url = `${BASE_URL}/company-admins?${queryParams.toString()}`;

console.log("🌐 Final API URL:", url);

const formatRange = (start, end) => {
  if (!start && !end) return "-";

  const format = (d) =>
    d
      ? convertUTCToLocalDateTime(d, {
          formatOptions: {
            day: "2-digit",
            month: "short",
            year: "numeric",
          },
        })
      : "-";

  return `${format(start)} - ${format(end)}`;
};
    // const url = `${BASE_URL}/company-admins?page=${pageNum + 1}&limit=${limit}&sort_by=${sortBy}&sort_order=${sortOrder.toUpperCase()}&status=active&search=${encodeURIComponent(keyword)}`;

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    const result = await res.json();

    if (result.error === false) {
      const mappedRows = result.data.company_admins.map(item => ({
        id: item.id,
        admin: item.full_name,
        company: item.company_name,
        country: item.country,
        active:item.current_employees,
        users: item.max_employees,
        email: item.email,
        businessEmail:item.business_email,
        // subscription: item.subscription_plan,
         subscription: planNameMap[item.subscription_plan] || item.subscription_plan,
                   subscriptionStatus: item.subscription_status,

        status: (item.status || '').toLowerCase(),
        verificationStatus: (item.verification_status || '').toLowerCase(),
      date: convertUTCToLocalDateTime(item.created_at),
          subscriptionPeriod: formatRange(
    item.subscription_start_date,
    item.subscription_end_date
  ),

  trialPeriod: formatRange(
    item.trial_start_date,
    item.trial_end_date
  ),
      }));

      setTableRows(mappedRows);
      setTotalPages(result.data.pagination.pages);
      setTotalRows(result.data.pagination.total);
    } else {
      toast.error(result.message || 'Failed to fetch data');
    }
  } catch (err) {
    toast.error('Something went wrong!');
  } finally {
  setLoading(false);
    setTableProcessing(false);
    setFirstLoadDone(true);  
  }
};


  const isFilterApplied = Object.values(filters).some(f => f && f !== '');
const hasMounted = useRef(false);



useEffect(() => {
  const delayDebounce = setTimeout(() => {
    fetchCompanyAdmins(
      page,
      rowsPerPage,
      sortConfig.key,
      sortConfig.direction,
      true,
      searchTerm,
      filters // ✅ pass filters here
    );
  }, 500);

  return () => clearTimeout(delayDebounce);
}, [sortConfig, searchTerm, page, rowsPerPage, filters]); //

const HaederStyles = {
  color: "#44546F",
  fontSize: "12px",
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 600,

};
const DataStyles = {
  color: "#172B4D",
  fontSize: "12px",
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 400,
    whiteSpace: 'nowrap',
  
      overflow: 'hidden',
  textOverflow: 'ellipsis',
};
const statusStyles = {
  Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
  Invited: { backgroundColor: '#579DFF', color: '#09326C' }, // optional fallback style
  Trial: { backgroundColor: '#FEA362', color: '#702E00' },
  Active: { backgroundColor: '#4BCE97', color: '#164B35' },
 verified: { backgroundColor: '#2196F3', color: '#0D47A1' },
   rejected: { backgroundColor: '#F87168', color: '#5D1F1A' },
pending: { backgroundColor: '#F5CD47', color: '#533F04' },
};
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loadingExport, setLoadingExport] = useState(false);
  const handleExportPDF = async () => {
  setLoadingExport(true);
  const blob = await pdf(<ActiveCompaniesPDF data={tableRows} />).toBlob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'Active_Companies_Report.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => setLoadingExport(false), 1000);
};
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);

  // const [tableRows, setTableRows] = useState(data);
          const statusButtonStyles = {
    active: { backgroundColor: '#4BCE97', color: '#164B35'},
    inactive: { backgroundColor: ' #F87168', color: '#5D1F1A' },
      requested: {  backgroundColor: '#F5CD47', color: '#533F04'  },
         invited: { backgroundColor: '#579DFF', color: '#09326C' },
          verified: { backgroundColor: '#2196F3', color: '#0D47A1' },
   rejected: { backgroundColor: '#F87168', color: '#5D1F1A' },
pending: { backgroundColor: '#F5CD47', color: '#533F04' },
};
 

const [sortLoading, setSortLoading] = useState(false);
   
 const columns = [
  { key: 'id', label: t('activeCompanies.columns.id') },
  { key: 'admin', label: t('activeCompanies.columns.admin') },
  { key: 'company', label: t('activeCompanies.columns.company') },
  { key: 'country', label: t('activeCompanies.columns.country') },
   { key: 'active', label: t('activeUsers') },
  { key: 'users', label: t('maxUsers') },
  { key: 'email', label: t('activeCompanies.columns.email') },
  { key: 'subscription', label: t('subscriptionPlan') },
    { key: 'subscriptionStatus', label: t('subscriptionStatus') },

  { key: 'status', label: t('activeCompanies.columns.status') },
  {key: 'verificationStatus', label: t("invites.columns.verificationStatus") },
  { key: 'date', label: t('DateTime') },
     { key: 'subscriptionPeriod', label: t("subscriptionPeriod") },
{ key: 'trialPeriod', label: t("trialPeriod") },
  { key: 'action', label: t('activeCompanies.columns.action') }
];

const fieldMap = {
  admin: 'full_name',
  company: 'company_name',
  country: 'country',
  users: 'max_employees',
  email: 'email',
  subscription: 'subscription_plan',
  status: 'status',
  date: 'created_at',
  id: 'id',
};
  const handleSort = (columnKey) => {
    const backendKey = fieldMap[columnKey] || columnKey
    const direction = sortConfig.key === backendKey && sortConfig.direction === "asc" ? "desc" : "asc"

    sortTriggeredByUser.current = true // Mark as user-triggered
    setSortConfig({ key: backendKey, direction })
  }

  useEffect(() => {

    fetchCompanyAdmins(page, rowsPerPage, "email", "desc", false)
  }, [page, rowsPerPage])
  const filteredRows = originalRows;

  const sortedRows = [...filteredRows].sort((a, b) => {
    const { key, direction } = sortConfig;
    if (!key || key === 'action') return 0;

    const numericFields = ['users'];
    let valA = a[key] ?? '';
    let valB = b[key] ?? '';

    if (numericFields.includes(key)) {
      valA = parseFloat(valA);
      valB = parseFloat(valB);
    } else {
      valA = valA.toString().toLowerCase();
      valB = valB.toString().toLowerCase();
    }

    return direction === 'asc' ? valA > valB ? 1 : -1 : valA < valB ? 1 : -1;
  });

  // const paginatedRows = sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const paginatedRows = tableRows; 
  const allSelected = tableRows.length > 0 && selected.length === tableRows.length;
const isIndeterminate = selected.length > 0 && !allSelected;

const handleStatusUpdate = async (status) => {
  if (selected.length === 0) {
    toast.error("No companies selected");
    return;
  }

  setStatusUpdating(status);

  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

  const payload = {
    company_admin_ids: selected,
    status: status,
    verification_status: 'verified',
  };

  try {
    const res = await fetch(`${BASE_URL}/company-admins/status`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const result = await res.json();
    if (result.error === false) {
      toast.success(result.message || `Status updated to "${status}"`);

      const updated = tableRows.map((row) => {
  if (selected.includes(row.id)) {

    let cleanedSubscription;
try {
  if (typeof row.subscription === 'string') {
    const parsed = JSON.parse(row.subscription);
    cleanedSubscription = typeof parsed === 'object'
      ? Object.keys(parsed)[0] || 'N/A'
      : row.subscription;
  } else if (typeof row.subscription === 'object') {
    cleanedSubscription = Object.keys(row.subscription)[0] || 'N/A';
  } else {
    cleanedSubscription = row.subscription || 'N/A';
  }
} catch {
  cleanedSubscription = row.subscription || 'N/A';
}

    return {
      ...row,
      status,
      subscription: cleanedSubscription,
    };
  }
  return row;
});

setTableRows(updated);
      setSelected([]);
    } else {
      toast.error(result.message || "Failed to update status");
    }
  } catch (err) {
    console.error("Status update failed:", err);
    toast.error("Something went wrong while updating status.");
  } finally {
    setStatusUpdating(null);
  }
};
const handleRowStatusUpdate = async (newStatus, id, currentVerificationStatus) => {
  if (!id) return;

  setRowStatusUpdatingId(id);
  const normalizedStatus = String(newStatus || "").toLowerCase();

  const payload = {
    company_admin_ids: [id],
    status: normalizedStatus,
    verification_status: currentVerificationStatus || "verified",
  };

  try {
    const res = await fetch(`${BASE_URL}/company-admins/status`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const result = await res.json();
    if (result.error === false) {
      toast.success(result.message || `Status updated to "${normalizedStatus}"`);

      setTableRows((prev) =>
        prev.map((row) =>
          row.id === id
            ? {
                ...row,
                status: normalizedStatus,
              }
            : row
        )
      );
    } else {
      toast.error(result.message || "Failed to update status");
    }
  } catch (err) {
    console.error("Row status update failed:", err);
    toast.error("Something went wrong while updating status.");
  } finally {
    setRowStatusUpdatingId(null);
  }
};
const statusValues = ['active', 'inactive', 'invited', 'requested'];

const statusOptions = statusValues.map((value) => ({
  label: t(`statusOptions.${value}`),
  value,
}));
const [verifyingId, setVerifyingId] = useState(null);
const handleVerificationStatusUpdate = async (verificationStatus, id) => {
  if (!id) {
    toast.error("No ID selected.");
    return;
  }
 setVerifyingId(id); 
  const payload = {
    company_admin_ids: [id],
    status: tableRows.find(row => row.id === id)?.status || 'invited', // keep current status
    verification_status: verificationStatus,
  };

  const url = `${BASE_URL}/company-admins/status`;

  try {
    const res = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const result = await res.json();

    if (result.error === false) {
      toast.success(`Verification status updated to "${verificationStatus}"`);

      const updated = [...tableRows];
      const index = updated.findIndex(row => row.id === id);
      if (index !== -1) {
        updated[index].verificationStatus = verificationStatus;
        setTableRows(updated);
      }
    } else {
      toast.error(result.message || "Failed to update verification status");
    }
  } catch (err) {
    console.error("❌ Error in verification update:", err);
    toast.error("Something went wrong while updating verification status.");
  }
   finally {
    setVerifyingId(null); // End loader
  }
};

const handleSearchChange = (e) => {
  setPage(0); // go to first page
  setSearchTerm(e.target.value);
};



const menuAnchorsRef = useRef({});
const [anchorEl, setAnchorEl] = useState(null);
const [menuRowId, setMenuRowId] = useState(null);


const handleViewClick = async () => {
  if (!menuRowId) return;

  try {
    setLoading(true);
    const res = await fetch(`${BASE_URL}/company-admins/${menuRowId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const json = await res.json();
    if (!json.error && json.data?.company_admin) {
      setSelectedRow(json.data.company_admin);
    } else {
      toast.error("Failed to fetch company admin details");
    }
  } catch (err) {
    toast.error("Error fetching details");
  } finally {
    setLoading(false);
    setAnchorEl(null); // close menu
  }
};

const handleMessagesClick = () => {
  if (!menuRowId) return;
  
  const selectedCompanyAdmin = tableRows.find(row => row.id === menuRowId);
  if (selectedCompanyAdmin) {
    navigate('/messages', {
      state: {
        openChatWith: {
          id: selectedCompanyAdmin.id,
          name: selectedCompanyAdmin.admin,
          email: selectedCompanyAdmin.email,
        },
        chatType: 'company_admin'
      }
    });
  }
  setAnchorEl(null);
};

// true if any filter set

const clearFilters = () => {
  const clearedFilters = {
    subscription_plan: '',
    subscription_status: '',
    verification_status: '',
    start_date: '',
    end_date: '',
    country:'',
    state:'',
    city:''
  };
  setFilters(clearedFilters);
  setPage(0);
};

const fetchAllActiveCompanies = async () => {
  const queryParams = new URLSearchParams({
    no_pagination: "true",
    status: "active",
    sort_by: sortConfig.key || "date",
    sort_order: sortConfig.direction?.toUpperCase() || "DESC",
  });
// COUNTRY filter
if (filters.country) {
  queryParams.append('country', filters.country);
}

// STATE filter (province → state for backend)
if (filters.state) {
  queryParams.append('state', filters.state);
}

// CITY filter
if (filters.city) {
  queryParams.append('city', filters.city);
}
  if (searchTerm) queryParams.append("search", searchTerm);
  if (filters.subscription_plan) {
    queryParams.append("subscription_plan", filters.subscription_plan);
  }
  if (filters.subscription_status) {
    queryParams.append("subscription_status", filters.subscription_status);
  }
  if (filters.start_date) queryParams.append("start_date", filters.start_date);
  if (filters.end_date) queryParams.append("end_date", filters.end_date);

  const res = await fetch(
    `${BASE_URL}/company-admins?${queryParams.toString()}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  const result = await res.json();
  const admins = result?.data?.company_admins || [];

  return admins.map((item) => ({
    id: item.id,
    admin: item.full_name,
    company: item.company_name,
    country: item.country,
    active:item.current_employees,
    users: item.max_employees,
    email: item.email,
    subscription:
      typeof item.subscription_plan === "string"
        ? item.subscription_plan
        : typeof item.subscription_plan === "object"
        ? Object.keys(item.subscription_plan)[0] || "N/A"
        : "N/A",
    status: (item.status || "").toLowerCase(),
    verificationStatus: (item.verification_status || "").toLowerCase(),
date: convertUTCToLocalDateTime(item.created_at),
  }));
};

const [deleteModalOpen, setDeleteModalOpen] = useState(false);
const [deleteLoading, setDeleteLoading] = useState(false);
const [selectedDeleteUser, setSelectedDeleteUser] = useState(null);
const handleDeleteClick = (row) => {
  setSelectedDeleteUser(row);
  setDeleteModalOpen(true);
};

const deleteAccountExecutive = async (reason) => {
  if (!selectedDeleteUser) return;

  setDeleteLoading(true);

  try {
    const body = {
      target_user_id: selectedDeleteUser.id,
      target_role: "company_admin",  // ALWAYS fixed role
      deletion_reason: reason,       // textarea value
      business_justification: reason // using same textarea
    };

    const res = await fetch(`${BASE_URL}/deletion-requests`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    const json = await res.json();

    if (res.ok && !json.error) {
toast.success(t("messages.deletionRequestSuccess"));
    } else {
      toast.error(json.message || "Failed to submit deletion request");
    }

    setDeleteModalOpen(false);
    setDeleteLoading(false);

    fetchCompanyAdmins(); // refresh table
  } catch (err) {
    console.error("Request failed", err);
toast.error(t("errors.somethingWentWrong"));
    setDeleteLoading(false);
  }
};
const getStatusConfig = (status) => {
  switch (status) {
    case "active":
      return {
        showArrow: true,
        options: ["inactive"],
        disabled: false,
      };

    case "invited":
    case "requested":
      return {
        showArrow: true,
        options: ["active", "inactive"],
        disabled: false,
      };

    case "inactive":
      return {
        showArrow: true,
        options: ["active"],
        disabled: false,
      };

    default:
      return {
        showArrow: false,
        options: [],
        disabled: true,
      };
  }
};

const getVerificationConfig = (status) => {
  if (status === "pending") {
    return {
      showArrow: true,
      options: [ "verified", "rejected"],
      disabled: false,
    };
  }

  return {
    showArrow: false,
    options: [],
    disabled: true,
  };
};
const mapFilters = {
  verification_status: filters.verification_status,
  start_date: filters.start_date,
  end_date: filters.end_date,
  country: filters.country,
  state: filters.state,
  city: filters.city,
   trial_end_date_from: filters.trial_end_date_from,
  trial_end_date_to: filters.trial_end_date_to,

  subscription_start_date_from: filters.subscription_start_date_from,
  subscription_start_date_to: filters.subscription_start_date_to,
   subscription_status: filters.subscription_status,

};

  return (
    <Box sx={{ py:2,px:1}}>
    
      <Toaster/>
    
          {/* {selectedRow ? (
  <ActiveDetails selectedRow={selectedRow} onClose={() => setSelectedRow(null)} />
) : (<> */}
    {loading ? (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'calc(100vh - 120px)',
        }}
      >
        <CircularProgress sx={{ color: '#006EC2' }} size={40} thickness={4} />
      </Box>
    ) : selectedRow ? (
      <ActiveDetails selectedRow={selectedRow} onClose={() => setSelectedRow(null)} />
    ) : (
      <>

        <Box sx={{mb:2,}}>
            <ActivePins selectedClientId={selectedClientId} 
            onClearClientId={() => setSelectedClientId(null)}
             filters={mapFilters}
  page={page}
  limit={rowsPerPage} 
  search={searchTerm}
   />
            </Box>
            
      <Box sx={{ backgroundColor: '#fff', borderRadius: 2, py: 2, border: '1px solid #E4E6EF' }}>
 
<Box
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 2,
    mb: 2,
    flexWrap: 'wrap',
    rowGap: 1,
  }}
>
  {/* <CustomText sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149", textAlign: "left" }}>
  {t('activeCompanies.title')}
  </CustomText> */}

<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
 <CustomText sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149", textAlign: "left" }}>
  {t('activeCompanies.title')}
  </CustomText>
{tableProcessing && (
    <CircularProgress size={18} thickness={4} sx={{ color: '#006EC2' }} />
  )}
</Box>
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      flexWrap: 'wrap',
      flexGrow: 1,
      justifyContent: selected.length === 0 ? 'center' : 'flex-end',
    }}
  >
    {selected.length > 0 ? (

  statusOptions.map(({ label, value }) => (
  <Button
        key={label}
        onClick={() => handleStatusUpdate(value)}
        variant="contained"
        size="small"
        sx={{
          px: 2,
          height: 34,
          fontSize: 13,
          fontWeight: 400,
          fontFamily: 'Poppins, sans-serif',
          borderRadius: '4px',
          textTransform: 'none',
          backgroundColor: statusButtonStyles[value]?.backgroundColor,
          color: statusButtonStyles[value]?.color,
          '&:hover': {
            backgroundColor: statusButtonStyles[value]?.backgroundColor,
            opacity: 0.9,
          },
        }}
      >
         {statusUpdating === value && (
          <CircularProgress
            size={16}
            thickness={4}
            sx={{ color: statusButtonStyles[value]?.color, mr: 1 }}
          />
        )}
        {label}
      </Button>
      ))
    ) : (

      <>
        <Box
          sx={{
            mx: 'auto',
            px: 0.5,
            py: 0.2,
            borderRadius: 1,
            height: 34,
            border: '2px solid #091E4224',
            display: 'flex',
            alignItems: 'center',
            minWidth: 250,
          }}
        >
          <InputBase
      value={searchTerm}
  onChange={handleSearchChange}
  placeholder={t('adminNameEmail')}
            sx={{
              ml: 0.5,
              fontSize: 15,
              letterSpacing: '1px',
              color: '#939393',
              fontWeight: 500,
              width: '100%',
            }}
          />
          <SearchIcon sx={{ fontSize: 22, color: '#888', mr: 0.5 }} />
        </Box>
<ExportDropdown
  onDownloadPDF={async () => {
    const allData = await fetchAllActiveCompanies(); // 👈 fetch all filtered results
    const blobStream = pdf(<ActiveCompaniesPDF data={allData} />).toBlob();
    blobStream.then((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Active_Companies_Report_${new Date()
        .toISOString()
        .slice(0, 10)}.pdf`;
      link.click();
    });
  }}
  onDownloadExcel={async () => {
    const allData = await fetchAllActiveCompanies(); // 👈 fetch all filtered results
    ExportActiveCompaniesExcel(allData);
  }}
/>

    {isFilterApplied ? (
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 34,
      height: 34,
      borderRadius: 1,
      bgcolor: "#006EC2", // blue background when filter applied
    }}
  >
    {/* Filter Icon */}
    <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

    {/* Small Cross Badge */}
    <IconButton
      size="small"
      onClick={clearFilters}
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        bgcolor: "white",
        width: 18,
        height: 18,
        border: "1px solid #C4C4C4",
        "&:hover": { bgcolor: "#f5f5f5" },
      }}
    >
      <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
    </IconButton>
  </Box>
) : (
  <IconButton
    onClick={() => setFilterDrawerOpen(true)}
    sx={{
      border: "1px solid #C4C4C4",
      borderRadius: 1,
      width: 34,
      height: 34,
      backgroundColor: "white",
      color: "#5E5C5C",
      "&:hover": { backgroundColor: "#F2F2F2" },
    }}
  >
    <FilterAltIcon sx={{ fontSize: 22 }} />
  </IconButton>
)}
      </>
    )}
  </Box>
</Box>

        <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
          <Table size="small">
            <TableHead  sx={{
                whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
            }}>
           
                          <TableRow>

              {columns.map((col) => (
                <TableCell key={col.key} 
                sx={{ ...HaederStyles, py: '6px', px: '2px', }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: col.key === 'action' ? 'flex-start' : 'center' }}>
                    {col.label}
                    {col.key !== 'action' && (
                      <IconButton size="small" onClick={() => handleSort(col.key)}>
                        {sortConfig.key === col.key && sortConfig.direction === 'asc' ? (
                          <NorthIcon sx={{ fontSize: '14px' }} />
                        ) : (
                          <SouthIcon sx={{ fontSize: '14px' }} />
                        )}
                      </IconButton>
                    )}
                  </Box>
                </TableCell>
              ))}
            </TableRow>
            </TableHead>
            {/* <TableBody>
            
            {paginatedRows.map((row, index) => ( */}
     
<TableBody>
  {paginatedRows.length === 0 ? (
    <TableRow>
      <TableCell colSpan={columns.length + 1}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: 300,
          }}
        >
          <img src={emptyscreen} alt="No Data" style={{ width: 200 }} />
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 500,
              fontSize: "16px",
              color: "#003149",
              pt: 1,
            }}
          >
            {t("empty.no_user")}
          </CustomText>
        </Box>
      </TableCell>
    </TableRow>
  ) : (
    paginatedRows.map((row, index) => {
      const {
        showArrow: statusShowArrow,
        options: statusOptions,
        disabled: statusDisabled,
      } = getStatusConfig(row.status);

      const {
        showArrow: verificationShowArrow,
        options: verificationOptions,
        disabled: verificationDisabled,
      } = getVerificationConfig(row.verificationStatus);

      return (
        <TableRow
          key={row.id}
          hover
          onClick={() => setSelectedClientId(row.id)}
          sx={{ cursor: "pointer" }}
        >
          <TableCell sx={{ ...DataStyles, pl: 2 }}>{row.id}</TableCell>

          <TableCell sx={{ ...DataStyles }}>
            <CustomText sx={{ fontSize: 13, fontWeight: 500 }}>
              {row.admin || "-- "}
            </CustomText>
            <CustomText sx={{ fontSize: 12, color: "#5A5A5A" }}>
              {row.email|| "-- "}
            </CustomText>
          </TableCell>

          <TableCell sx={{ ...DataStyles }}>{row.company || "-- "}</TableCell>
          <TableCell sx={{ ...DataStyles }}>{row.country || "-- "}</TableCell>
          <TableCell sx={{ ...DataStyles, textAlign: "center" }}>
            {row.active || "-- "}
          </TableCell>
          <TableCell sx={{ ...DataStyles }}>{row.users || "-- "}</TableCell>
          <TableCell sx={{ ...DataStyles }}>{row.businessEmail || "-- "}</TableCell>

          <TableCell sx={{ ...DataStyles }}>
            {Array.isArray(row.subscription)
              ? row.subscription.join(", ")
              : String(row.subscription).replace(/[\[\]{}"]/g, "")}
          </TableCell>


<TableCell sx={{ ...DataStyles, width: 120 , textTransform: "capitalize" }}>
  {(row.subscriptionStatus || "-- ").replace(/_/g, " ")}
</TableCell>
          {/* STATUS */}
          <TableCell sx={{ textAlign: "center" }}>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                px: 0.6,
                py: 0.1,
                borderRadius: 1,
                backgroundColor:
                  statusButtonStyles[row.status]?.backgroundColor,
                color: statusButtonStyles[row.status]?.color,
                pointerEvents: statusDisabled ? "none" : "auto",
                cursor: statusDisabled ? "default" : "pointer",
              }}
            >
              {rowStatusUpdatingId === row.id && (
                <CircularProgress size={12} thickness={4} />
              )}
              <StatusDropdown
                currentStatus={row.status}
                showArrow={statusShowArrow}
                statusOptions={statusOptions}
                onChange={(newStatus) => {
                  if (!statusOptions.includes(newStatus)) return;
                  handleRowStatusUpdate(
                    newStatus,
                    row.id,
                    row.verificationStatus
                  );
                }}
              />
            </Box>
          </TableCell>

          {/* VERIFICATION STATUS */}
          <TableCell sx={{ textAlign: "center" }}>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                px: 0.6,
                py: 0.1,
                borderRadius: 1,
                backgroundColor:
                  statusButtonStyles[row.verificationStatus]
                    ?.backgroundColor,
                color:
                  statusButtonStyles[row.verificationStatus]?.color,
                pointerEvents: verificationDisabled ? "none" : "auto",
                cursor: verificationDisabled ? "default" : "pointer",
              }}
            >
              {verifyingId === row.id && (
                <CircularProgress size={12} thickness={4} />
              )}

              <ArrowStatusDropdown
                currentStatus={row.verificationStatus}
                showArrow={verificationShowArrow}
                statusOptions={verificationOptions}
                onChange={(newStatus) => {
                  if (!verificationOptions.includes(newStatus)) return;
                  handleVerificationStatusUpdate(newStatus, row.id);
                }}
              />
            </Box>
          </TableCell>

          <TableCell sx={{ ...DataStyles }}>{row.date}</TableCell>



<TableCell sx={{ ...DataStyles, width: 220 }}>
  {row.subscriptionPeriod}
</TableCell>
<TableCell sx={{ ...DataStyles, width: 220 }}>
  {row.trialPeriod}
</TableCell>
          <TableCell>
            <IconButton
              ref={(el) => {
                if (el) menuAnchorsRef.current[row.id] = el;
              }}
              onClick={() => {
                setAnchorEl(menuAnchorsRef.current[row.id]);
                setMenuRowId(row.id);
              }}
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    })
  )}
</TableBody>


          </Table>
        </TableContainer>

                                         <Menu
           sx={{fontSize:"15px",boxShadow:"none"}}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
            anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'center',
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'center',
  }}
            PaperProps={{
            sx: {
              // minWidth: 80,
              // paddingY: 0.5,
              // boxShadow:"none",
              // border: '1px solid #E0E0E0',
            },
          }}
          MenuListProps={{
            sx: {
              paddingY: 0,
            },
          }}
        >
          <MenuItem onClick={handleViewClick} sx={{fontSize:"14px",
               fontFamily: 'Poppins, sans-serif',
          }}>{t("common.view")}</MenuItem>
      <MenuItem onClick={handleMessagesClick} sx={{fontSize:"14px",
            fontFamily: 'Poppins, sans-serif',
       }}>{t("messages")}</MenuItem>
   {/* <MenuItem
  sx={{
    fontSize: "14px",
    fontFamily: "Poppins, sans-serif",
  }}
  onClick={() => {
    const row = tableRows.find(r => r.id === menuRowId); // lookup row
    setSelectedDeleteUser(row);
    setDeleteModalOpen(true);
    setAnchorEl(null);
  }}
>
  {t("common.delete")}
</MenuItem> */}
        </Menu>
    

<Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>

               <Box sx={{ display: 'flex',flexWrap:"wrap", justifyContent: 'center', mt: 2 }}>
              <Pagination
    count={totalPages}
    page={page + 1}
    onChange={(e, value) => setPage(value - 1)}
    shape="rounded"
    color="primary"
    size="small"
    sx={{
      '& .MuiPaginationItem-root': {
        fontFamily: 'Poppins, sans-serif',
        fontSize: 13,
        fontWeight: 500,
      },
      '& .Mui-selected': {
        backgroundColor: '#E9F3FF',
        color: '#006EC2',
      },
    }}
  />
  </Box>


</Box>
      </Box>
      </>
      )}

<FilterDrawer
  open={filterDrawerOpen}
  onClose={() => setFilterDrawerOpen(false)}
  filters={filters}
  setFilters={setFilters}
onApplyFilters={(updatedFilters) => {
  console.log("🎯 Filter applied from drawer:", updatedFilters);
  setFilters(updatedFilters);
  setPage(0);
  fetchCompanyAdmins(
    0,
    rowsPerPage,
    sortConfig.key || 'email',
    sortConfig.direction || 'desc',
    false,
    searchTerm,
    updatedFilters
  );
  setFilterDrawerOpen(false);
}}
/>

<DeleteAccountExecutiveModal
  open={deleteModalOpen}
  onClose={() => setDeleteModalOpen(false)}
  onConfirm={(reason) => deleteAccountExecutive(reason)}
  loading={deleteLoading}
  name={selectedDeleteUser?.name}
/>

    </Box>
  );
};

export default ActiveCompanies;
























